import { render, staticRenderFns } from "./content_main.vue?vue&type=template&id=781ab09c&scoped=true&"
import script from "./content_main.vue?vue&type=script&lang=js&"
export * from "./content_main.vue?vue&type=script&lang=js&"
import style0 from "./content_main.vue?vue&type=style&index=0&id=781ab09c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781ab09c",
  null
  
)

export default component.exports